module.exports = __webpack_public_path__ + "img/CRC1_pDC.397658e3.png";